import React from 'react';
import styled from 'styled-components';

import { Link } from '@lt/components';

import Card from '../../../Card';
import CardImage from '../../../CardImage';
import { cardHeadingTextStyles } from '../../../CardHeading/CardHeading';

import { RELINKING_VARIANTS } from '../../../../constants';
import type { INarrativeCard } from '../../types';

export const NarrativeCard = (props: INarrativeCard) => {
  const { title, text, redirect_url: redirectUrl, image, isMobile } = props;
  const { x240x150: src, webp_x240x150: fallback } = image;

  const url = new URL(redirectUrl);
  url.searchParams.set('ref_content', 'main_page');

  return (
    <Card $isMobile={isMobile} $variant={RELINKING_VARIANTS.NARRATIVE}>
      <StyledLink href={url.href}>
        <StyledCardImage src={src} fallback={fallback} />
        <StyledCardHeading $isMobile={isMobile} $isBlack $hasMarginTop={false}>
          {title}
        </StyledCardHeading>
        <StyledCardText>{text}</StyledCardText>
      </StyledLink>
    </Card>
  );
};

const StyledLink = styled(Link)`
  color: #17181a;
  display: block;
`;

const StyledCardImage = styled(CardImage)`
  margin-bottom: 8px;
  height: 150px;

  border: none;
  border-radius: 4px;
`;

const StyledCardHeading = styled.p<{
  $isMobile: boolean;
  $isBlack: boolean;
  $hasMarginTop: boolean;
}>`
  ${cardHeadingTextStyles}
`;

const StyledCardText = styled.p`
  margin-left: 4px;
`;
